'use strict'

export default {
    subscribe(email, status) {

        if (!status) {
            status = 'subscribed';
        }

        return new Promise((resolve, reject) => {
            axios({
                method: 'POST',
                url: '/api/newsletter/subscribe',
                headers: {
                    'content-type': 'application/json'
                },
                data: {
                    email: email,
                    status: status,
                }
            })
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Services/Marketing.js